export default __webpack_public_path__ + "static/media/premium-efficiency.b7703d42.png";